import React from "react";
import Assets from "./components/Assets";
import TradeWidget from "./components/TradeWidget";

const Home = (props) => {
  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-lg-8 col-12 order-1 order-lg-0">
          <Assets {...props} />
        </div>
        <div className="col-lg-4 col-12 mt-0 mt-lg-0 mb-3 order-0 order-lg-1">
          <TradeWidget {...props}/>
        </div>
      </div>
    </div>
  );
};

export default Home;
